/**
 * KiekkoKingi section controller: experiences
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (function () {
        const rootId = kkScript.dataset.rootId;
        var registry = window.__kiekkokingExperiencesControllers = window.__kiekkokingExperiencesControllers || { items: {}, bound: false };
  
        function destroy(id) {
          var controller = registry.items[id];
          if (!controller) return;
          if (controller.observer) controller.observer.disconnect();
          if (controller.mediaQuery && controller.onViewportChange) controller.mediaQuery.removeEventListener('change', controller.onViewportChange);
          controller.videos.forEach(function (item) {
            if (item.toggle && item.onToggle) item.toggle.removeEventListener('click', item.onToggle);
            if (item.video && item.onState) {
              item.video.removeEventListener('play', item.onState);
              item.video.removeEventListener('pause', item.onState);
              item.video.removeEventListener('ended', item.onState);
              item.video.pause();
            }
          });
          delete registry.items[id];
        }
  
        registry.init = function (root) {
          if (!root || !root.id) return;
          destroy(root.id);
  
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var mobileQuery = window.matchMedia('(max-width: 719px)');
          var allowMobileVideo = root.getAttribute('data-video-mobile') === 'true';
          var shouldAutoplay = root.getAttribute('data-video-autoplay') === 'true';
          var motion = root.getAttribute('data-motion') || 'none';
          var controller = { root: root, videos: [], observer: null, mediaQuery: mobileQuery, onViewportChange: null, inView: false };
  
          registry.items[root.id] = controller;
  
          function videoAllowed() {
            return !mobileQuery.matches || allowMobileVideo;
          }
  
          Array.prototype.forEach.call(root.querySelectorAll('[data-kk-experience-video]'), function (video) {
            var card = video.closest('.kk-experiences__card-surface');
            var toggle = card ? card.querySelector('[data-kk-experience-video-toggle]') : null;
            var item = { video: video, toggle: toggle, hydrated: false, onToggle: null, onState: null };
            controller.videos.push(item);
  
            function hydrate() {
              if (item.hydrated || !videoAllowed()) return;
              var sources = [];
              try { sources = JSON.parse(video.getAttribute('data-video-sources') || '[]'); } catch (error) { sources = []; }
              sources.forEach(function (sourceData) {
                var source = document.createElement('source');
                source.src = sourceData.url;
                source.type = sourceData.mime_type || sourceData.mimeType || '';
                video.appendChild(source);
              });
              item.hydrated = true;
              video.preload = 'metadata';
              if (sources.length) video.load();
            }
  
            function updateControl() {
              if (!toggle) return;
              var playing = !video.paused && !video.ended;
              var playIcon = toggle.querySelector('[data-kk-icon-play]');
              var pauseIcon = toggle.querySelector('[data-kk-icon-pause]');
              toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
              toggle.setAttribute('aria-label', playing ? (root.dataset.videoPauseLabel || '') : (root.dataset.videoPlayLabel || ''));
              if (playIcon) playIcon.toggleAttribute('hidden', playing);
              if (pauseIcon) pauseIcon.toggleAttribute('hidden', !playing);
            }
  
            function play() {
              if (!videoAllowed()) return;
              hydrate();
              video.muted = true;
              var promise = video.play();
              if (promise && typeof promise.catch === 'function') promise.then(updateControl).catch(updateControl);
            }
  
            item.onState = updateControl;
            video.addEventListener('play', item.onState);
            video.addEventListener('pause', item.onState);
            video.addEventListener('ended', item.onState);
  
            if (toggle) {
              item.onToggle = function () {
                if (video.paused) play(); else video.pause();
                updateControl();
              };
              toggle.addEventListener('click', item.onToggle);
              updateControl();
            }
  
            item.hydrate = hydrate;
            item.play = play;
          });
  
          function activateVideos() {
            if (!controller.inView || reducedMotion || !shouldAutoplay || !videoAllowed()) return;
            controller.videos.forEach(function (item) { item.play(); });
          }
  
          controller.onViewportChange = function () {
            if (!videoAllowed()) {
              controller.videos.forEach(function (item) { item.video.pause(); });
              return;
            }
            activateVideos();
          };
          mobileQuery.addEventListener('change', controller.onViewportChange);
  
          if (motion !== 'none' && !reducedMotion) root.classList.add('is-motion-ready');
  
          function reveal() {
            controller.inView = true;
            root.classList.add('is-revealed');
            activateVideos();
          }
  
          if ('IntersectionObserver' in window) {
            controller.observer = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                reveal();
                controller.observer.disconnect();
              });
            }, { rootMargin: '140px 0px', threshold: 0.06 });
            controller.observer.observe(root);
          } else {
            reveal();
          }
  
          if (reducedMotion || motion === 'none') root.classList.add('is-revealed');
        };
  
        registry.init(document.getElementById(rootId));
  
        if (!registry.bound) {
          document.addEventListener('shopify:section:load', function (event) {
            var root = event.target.matches && event.target.matches('[data-kk-experiences]')
              ? event.target
              : event.target.querySelector && event.target.querySelector('[data-kk-experiences]');
            if (root) registry.init(root);
          });
  
          document.addEventListener('shopify:section:unload', function (event) {
            var root = event.target.matches && event.target.matches('[data-kk-experiences]')
              ? event.target
              : event.target.querySelector && event.target.querySelector('[data-kk-experiences]');
            if (root) destroy(root.id);
          });
  
          registry.bound = true;
        }
      })();
})();
